/*
 * <swipe-slider class="swiper" data-swiper-options='{"slidesPerView":"auto"}'>
 *   <ul class="swiper-wrapper" role="list"><li class="swiper-slide">…</li></ul>
 *   <div class="swiper-scrollbar"></div>  (optional, becomes a draggable progress bar)
 * </swipe-slider>
 *
 * Initialises the globally loaded Swiper (touch swipe + mouse drag) with
 * data-swiper-options merged over the defaults below, and destroys it when the
 * element is removed, e.g. when the theme editor re-renders the section.
 */
if (!customElements.get('swipe-slider')) {
  customElements.define(
    'swipe-slider',
    class SwipeSlider extends HTMLElement {
      connectedCallback() {
        if (this.swiper || typeof Swiper === 'undefined' || !this.dataset.swiperOptions) return;

        const scrollbar = this.querySelector('.swiper-scrollbar');
        this.swiper = new Swiper(this, {
          grabCursor: true,
          a11y: { slideRole: 'listitem' },
          ...(scrollbar && { scrollbar: { el: scrollbar, draggable: true } }),
          ...JSON.parse(this.dataset.swiperOptions),
        });

        this.swiper.on('lock', () => this.swiper.unsetGrabCursor());
        this.swiper.on('unlock', () => this.swiper.params.grabCursor && this.swiper.setGrabCursor());

        this.onBlockSelect = (event) => {
          const index = this.swiper.slides.indexOf(event.target.closest('.swiper-slide'));
          if (index > -1) this.swiper.slideTo(index);
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        if (!this.swiper) return;

        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  );
}
